import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { postRole, updateRole, getRoleById } from "../../../store/actions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRef } from "react";
import Loading from "../../../Common/extra/loading";
import { MenuItem, Select } from "@material-ui/core";

// basic setting
const Permissions = [
  {
    name: "Accounts",
    id: "accounts",
  },
  {
    name: "Documents",
    id: "documents",
  },
  {
    name: "Contact Messages",
    id: "contact_messages",
  },
  {
    name: "Subscribers",
    id: "subscribers",
  },
  {
    name: "Financial Configuration",
    id: "finance_configure",
  },
  {
    name: "Sub Admin",
    id: "sub_admin",
  },
  {
    name: "Facebook",
    id: "facebook",
  },
  {
    name: "Instagram",
    id: "instagram",
  },
  {
    name: "Twitter",
    id: "twitter",
  },
  {
    name: "Youtube",
    id: "youtube",
  },
  {
    name: "Tiktok",
    id: "tiktok",
  },
  {
    name: "Template Categories",
    id: "template_categories",
  },
  {
    name: "Document Categories",
    id: "document_categories",
  },
  {
    name: "Email Template",
    id: "email_template",
  },
  {
    name: "SMS Template",
    id: "sms_template",
  },
  {
    name: "Document Template",
    id: "document_template",
  },
  {
    name: "Email Signature",
    id: "email_signature",
  },
  {
    name: "Notification Settings",
    id: "notification_settings",
  },
  {
    name: "Basic Settings",
    id: "basic_settings",
  },
  {
    name: "Landing Pages",
    id: "landing_pages",
  },
  {
    name: "Generate Embed Code",
    id: "generate_embed_code",
  },
  {
    name: "Health Insurance",
    id: "health_insurance",
  },
  { name: "Role & Permissions", id: "role_permissions" },
  { name: "Life Insurance", id: "life_insurance" },
];

const StatusList = [
  {
    name: "Active",
    id: "1",
  },
  {
    name: "Inactive",
    id: "0",
  },
];

const AddRoleIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const compMounted = useRef();
  const [loading, setLoading] = useState(false);
  const userData = useSelector((s) => s?.Signatures?.role?.data);
  const id = location.pathname.split("/")[3];
  const [data, setData] = useState({
    userId: "",
    name: "",
    status: "",
    permissions: [],
  });

  const [errors, setError] = useState({
    name: "",
    permissions: [],
    disabled: true,
  });

  useEffect(() => {
    if (compMounted.current) {
      setData((pre) => ({
        ...pre,
        name: userData?.name ? userData?.name : "",
        status: userData?.status ? userData?.status : "",
        permissions: userData?.permissions ? userData?.permissions : [],
      }));
    } else {
      compMounted.current = true;
    }
  }, [userData]);

  useEffect(() => {
    if (id) {
      dispatch(getRoleById(id));
    }
    setData((pre) => ({
      ...pre,
      userId: id,
    }));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const Error = { ...errors };

    switch (name) {
      case "name":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = false;

          ("");
        }
        break;

      default:
        break;
    }
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((pre) => ({ ...pre, ...Error }));
  };

  const handleMultipleChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({ ...pre, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const callBack = (response) => {
      setLoading(false);
      if (response.data) {
        toast.success("Added Successfully");
        setTimeout(() => {
          navigate("/role-permissions");
        }, 500);
      } else {
        setLoading(false);
      }
    };
    if (id) {
      if (data.userId) {
        data.userId = data.userId;
      }
      dispatch(updateRole(data, callBack));
    } else {
      dispatch(postRole(data, callBack));
    }
  };

  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/subadmins">
                    Roles & Permissions
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    {id ? "Edit" : "Add"}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Role Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={data?.name}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.name}
                      </span>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Permissions
                      </label>
                      <Select
                        className="demo-simple-select-label"
                        id="demo-simple-select"
                        multiple
                        name="permissions"
                        value={data.permissions}
                        onChange={handleMultipleChange}
                        MenuProps={Permissions}
                      >
                        {Permissions &&
                          Permissions.length > 0 &&
                          Permissions.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.permissions}
                      </span>
                    </Col>
                    {/* {data.userId && (
                      <Col lg="6" className="my-2 doc-select">
                        <label htmlFor="" className="form-label2 m-0">
                          Status
                        </label>
                        <Select
                          className="demo-simple-select-label"
                          id="demo-simple-select"
                          name="status"
                          value={data.status}
                          onChange={handleChange}
                          MenuProps={StatusList}
                        >
                          {StatusList &&
                            StatusList.length > 0 &&
                            StatusList.map((item, idx) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </Col>
                    )} */}

                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex algign-items-center">
                        <Button
                          disabled={
                            data.name == "" && data.permissions.length < 1
                              ? true
                              : false
                          }
                          onClick={handleSubmit}
                          className="d-flex align-items-center justify-content-center me-2"
                        >
                          Submit
                        </Button>
                        <Link
                          to={`/role-permissions`}
                          className="d-flex btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddRoleIndex;
